// extracted by mini-css-extract-plugin
module.exports = {"button":"LrvButton_button__1cEm4","lightButton":"LrvButton_lightButton__2wU2X","darkButton":"LrvButton_darkButton__18CAJ"};